import { render, staticRenderFns } from "./CreateDiscountForLesson.vue?vue&type=template&id=7963ee57"
import script from "./CreateDiscountForLesson.vue?vue&type=script&lang=js"
export * from "./CreateDiscountForLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports